/* eslint-disable max-len */
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';

import { performQuery } from 'lib/api';
import trackAction from 'utils/tracking';
import { AppContext } from 'context/AppContext';

import Modal from 'components/Core/Modal';
import IconSvg from 'components/Core/IconSvg';

import { FormInput as FormInputElem, FormLabel as FormLabelElem } from './AccommodationModal.styles';

const AccommodationModal = ({ title, updateLocation }) => {
  const [cityList, setCityList] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const { updateAppState } = useContext(AppContext);

  const closeModal = () => {
    document.body.classList.remove('modal-open');
    updateAppState((state) => ({
      ...state,
      openModal: false,
      showAccommodationModal: false,
    }));
  };

  const fetchCities = async (e) => {
    e.preventDefault();
    const { cities } = await performQuery(
      `query($q: String) {
          cities(q: $q) {
            name
            slug
            lat
            lon
          }
        }`,
      {
        q: searchQuery,
      },
    );

    setCityList(await cities);
    trackAction('change-location', 'search', searchQuery);
  };

  const onCitySelect = (city) => {
    closeModal();
    // on some mobile screens we need to return to the top
    if (typeof window !== 'undefined') window.scrollTo(0, 0);

    trackAction('change-location', 'choose-location', city.name);
    updateLocation(city);
  };

  return (
    <Modal>
      <h4 className="mb-8">{title}</h4>
      <form onSubmit={fetchCities} className="flex border-b-2 border-secondary relative">
        <FormInputElem
          id="location"
          type="text"
          name="q"
          className="rounded-none h-8 block w-full focus:outline-none"
          aria-label="Voer een plaatsnaam in"
          aria-required="true"
          placeholder=" "
          onChange={(e) => setSearchQuery(e.target.value)}
          value={searchQuery}
        />
        <FormLabelElem
          className="absolute top-0 left-0 pointer-events-none transition-all duration-150 text-basic-500"
          htmlFor="location"
        >
          Voer een plaatsnaam in
        </FormLabelElem>
        <button type="submit" aria-label="Zoek">
          <IconSvg className="text-primary" icon="search" />
        </button>
      </form>
      {!isEmpty(cityList) && (
        <div className="mt-4">
          {cityList.map((city, index) => (
            <button
              // eslint-disable-next-line react/no-array-index-key
              key={`city_${city.slug}_${index}`}
              type="button"
              className="flex items-center py-2 border-b-2 w-full hover:border-primary transition-colors duration-150 ease-out"
              onClick={() => onCitySelect(city)}
            >
              <IconSvg className="text-secondary mr-2" icon="location" size={28} />
              <div>{city.name}</div>
              <IconSvg className="text-primary ml-auto" icon="arrow-right" size={13} />
            </button>
          ))}
        </div>
      )}
    </Modal>
  );
};

AccommodationModal.propTypes = {
  title: PropTypes.string,
  updateLocation: PropTypes.func,
};

AccommodationModal.defaultProps = {
  title: 'Mijn locatie wijzigen',
  updateLocation: () => {},
};

export default AccommodationModal;
